export default // 20220718150851
// https://api.github.com/users/cetinsangu/subscriptions

[
  {
    id: 15648899,
    node_id: 'MDEwOlJlcG9zaXRvcnkxNTY0ODg5OQ==',
    name: 'coursera-android',
    full_name: 'aporter/coursera-android',
    private: false,
    owner: {
      login: 'aporter',
      id: 1117798,
      node_id: 'MDQ6VXNlcjExMTc3OTg=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1117798?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/aporter',
      html_url: 'https://github.com/aporter',
      followers_url: 'https://api.github.com/users/aporter/followers',
      following_url:
        'https://api.github.com/users/aporter/following{/other_user}',
      gists_url: 'https://api.github.com/users/aporter/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/aporter/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/aporter/subscriptions',
      organizations_url: 'https://api.github.com/users/aporter/orgs',
      repos_url: 'https://api.github.com/users/aporter/repos',
      events_url: 'https://api.github.com/users/aporter/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/aporter/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/aporter/coursera-android',
    description: 'Source Code for Android Course Example Applications',
    fork: false,
    url: 'https://api.github.com/repos/aporter/coursera-android',
    forks_url: 'https://api.github.com/repos/aporter/coursera-android/forks',
    keys_url:
      'https://api.github.com/repos/aporter/coursera-android/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/aporter/coursera-android/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/aporter/coursera-android/teams',
    hooks_url: 'https://api.github.com/repos/aporter/coursera-android/hooks',
    issue_events_url:
      'https://api.github.com/repos/aporter/coursera-android/issues/events{/number}',
    events_url: 'https://api.github.com/repos/aporter/coursera-android/events',
    assignees_url:
      'https://api.github.com/repos/aporter/coursera-android/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/aporter/coursera-android/branches{/branch}',
    tags_url: 'https://api.github.com/repos/aporter/coursera-android/tags',
    blobs_url:
      'https://api.github.com/repos/aporter/coursera-android/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/aporter/coursera-android/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/aporter/coursera-android/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/aporter/coursera-android/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/aporter/coursera-android/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/aporter/coursera-android/languages',
    stargazers_url:
      'https://api.github.com/repos/aporter/coursera-android/stargazers',
    contributors_url:
      'https://api.github.com/repos/aporter/coursera-android/contributors',
    subscribers_url:
      'https://api.github.com/repos/aporter/coursera-android/subscribers',
    subscription_url:
      'https://api.github.com/repos/aporter/coursera-android/subscription',
    commits_url:
      'https://api.github.com/repos/aporter/coursera-android/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/aporter/coursera-android/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/aporter/coursera-android/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/aporter/coursera-android/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/aporter/coursera-android/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/aporter/coursera-android/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/aporter/coursera-android/merges',
    archive_url:
      'https://api.github.com/repos/aporter/coursera-android/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/aporter/coursera-android/downloads',
    issues_url:
      'https://api.github.com/repos/aporter/coursera-android/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/aporter/coursera-android/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/aporter/coursera-android/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/aporter/coursera-android/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/aporter/coursera-android/labels{/name}',
    releases_url:
      'https://api.github.com/repos/aporter/coursera-android/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/aporter/coursera-android/deployments',
    created_at: '2014-01-05T09:55:31Z',
    updated_at: '2022-07-15T04:30:59Z',
    pushed_at: '2020-10-04T07:21:38Z',
    git_url: 'git://github.com/aporter/coursera-android.git',
    ssh_url: 'git@github.com:aporter/coursera-android.git',
    clone_url: 'https://github.com/aporter/coursera-android.git',
    svn_url: 'https://github.com/aporter/coursera-android',
    homepage: null,
    size: 22558,
    stargazers_count: 4280,
    watchers_count: 4280,
    language: 'Java',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 5429,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 65,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 5429,
    open_issues: 65,
    watchers: 4280,
    default_branch: 'master',
  },
  {
    id: 21113349,
    node_id: 'MDEwOlJlcG9zaXRvcnkyMTExMzM0OQ==',
    name: 'AndroidViewAnimations',
    full_name: 'daimajia/AndroidViewAnimations',
    private: false,
    owner: {
      login: 'daimajia',
      id: 2503423,
      node_id: 'MDQ6VXNlcjI1MDM0MjM=',
      avatar_url: 'https://avatars.githubusercontent.com/u/2503423?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/daimajia',
      html_url: 'https://github.com/daimajia',
      followers_url: 'https://api.github.com/users/daimajia/followers',
      following_url:
        'https://api.github.com/users/daimajia/following{/other_user}',
      gists_url: 'https://api.github.com/users/daimajia/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/daimajia/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/daimajia/subscriptions',
      organizations_url: 'https://api.github.com/users/daimajia/orgs',
      repos_url: 'https://api.github.com/users/daimajia/repos',
      events_url: 'https://api.github.com/users/daimajia/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/daimajia/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/daimajia/AndroidViewAnimations',
    description: 'Cute view animation collection.',
    fork: false,
    url: 'https://api.github.com/repos/daimajia/AndroidViewAnimations',
    forks_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/forks',
    keys_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/teams',
    hooks_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/hooks',
    issue_events_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/events',
    assignees_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/tags',
    blobs_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/languages',
    stargazers_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/stargazers',
    contributors_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/contributors',
    subscribers_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/subscribers',
    subscription_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/subscription',
    commits_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/merges',
    archive_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/downloads',
    issues_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/labels{/name}',
    releases_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/daimajia/AndroidViewAnimations/deployments',
    created_at: '2014-06-23T03:53:13Z',
    updated_at: '2022-07-18T09:16:57Z',
    pushed_at: '2021-08-18T23:15:07Z',
    git_url: 'git://github.com/daimajia/AndroidViewAnimations.git',
    ssh_url: 'git@github.com:daimajia/AndroidViewAnimations.git',
    clone_url: 'https://github.com/daimajia/AndroidViewAnimations.git',
    svn_url: 'https://github.com/daimajia/AndroidViewAnimations',
    homepage: '',
    size: 297,
    stargazers_count: 12135,
    watchers_count: 12135,
    language: 'Java',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2435,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 61,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['android', 'animation', 'easing-functions'],
    visibility: 'public',
    forks: 2435,
    open_issues: 61,
    watchers: 12135,
    default_branch: 'master',
  },
  {
    id: 23301468,
    node_id: 'MDEwOlJlcG9zaXRvcnkyMzMwMTQ2OA==',
    name: 'AndroidSwipeLayout',
    full_name: 'daimajia/AndroidSwipeLayout',
    private: false,
    owner: {
      login: 'daimajia',
      id: 2503423,
      node_id: 'MDQ6VXNlcjI1MDM0MjM=',
      avatar_url: 'https://avatars.githubusercontent.com/u/2503423?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/daimajia',
      html_url: 'https://github.com/daimajia',
      followers_url: 'https://api.github.com/users/daimajia/followers',
      following_url:
        'https://api.github.com/users/daimajia/following{/other_user}',
      gists_url: 'https://api.github.com/users/daimajia/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/daimajia/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/daimajia/subscriptions',
      organizations_url: 'https://api.github.com/users/daimajia/orgs',
      repos_url: 'https://api.github.com/users/daimajia/repos',
      events_url: 'https://api.github.com/users/daimajia/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/daimajia/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/daimajia/AndroidSwipeLayout',
    description: 'The Most Powerful Swipe Layout!',
    fork: false,
    url: 'https://api.github.com/repos/daimajia/AndroidSwipeLayout',
    forks_url: 'https://api.github.com/repos/daimajia/AndroidSwipeLayout/forks',
    keys_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/daimajia/AndroidSwipeLayout/teams',
    hooks_url: 'https://api.github.com/repos/daimajia/AndroidSwipeLayout/hooks',
    issue_events_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/events',
    assignees_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/branches{/branch}',
    tags_url: 'https://api.github.com/repos/daimajia/AndroidSwipeLayout/tags',
    blobs_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/languages',
    stargazers_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/stargazers',
    contributors_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/contributors',
    subscribers_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/subscribers',
    subscription_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/subscription',
    commits_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/merges',
    archive_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/downloads',
    issues_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/labels{/name}',
    releases_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/daimajia/AndroidSwipeLayout/deployments',
    created_at: '2014-08-25T04:09:33Z',
    updated_at: '2022-07-18T06:12:20Z',
    pushed_at: '2021-08-05T11:51:50Z',
    git_url: 'git://github.com/daimajia/AndroidSwipeLayout.git',
    ssh_url: 'git@github.com:daimajia/AndroidSwipeLayout.git',
    clone_url: 'https://github.com/daimajia/AndroidSwipeLayout.git',
    svn_url: 'https://github.com/daimajia/AndroidSwipeLayout',
    homepage: '',
    size: 399,
    stargazers_count: 12232,
    watchers_count: 12232,
    language: 'Java',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 2710,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 378,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 2710,
    open_issues: 378,
    watchers: 12232,
    default_branch: 'master',
  },
  {
    id: 28428729,
    node_id: 'MDEwOlJlcG9zaXRvcnkyODQyODcyOQ==',
    name: 'awesome-android-ui',
    full_name: 'wasabeef/awesome-android-ui',
    private: false,
    owner: {
      login: 'wasabeef',
      id: 1833474,
      node_id: 'MDQ6VXNlcjE4MzM0NzQ=',
      avatar_url: 'https://avatars.githubusercontent.com/u/1833474?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/wasabeef',
      html_url: 'https://github.com/wasabeef',
      followers_url: 'https://api.github.com/users/wasabeef/followers',
      following_url:
        'https://api.github.com/users/wasabeef/following{/other_user}',
      gists_url: 'https://api.github.com/users/wasabeef/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/wasabeef/starred{/owner}{/repo}',
      subscriptions_url: 'https://api.github.com/users/wasabeef/subscriptions',
      organizations_url: 'https://api.github.com/users/wasabeef/orgs',
      repos_url: 'https://api.github.com/users/wasabeef/repos',
      events_url: 'https://api.github.com/users/wasabeef/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/wasabeef/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/wasabeef/awesome-android-ui',
    description: 'A curated list of awesome Android UI/UX libraries',
    fork: false,
    url: 'https://api.github.com/repos/wasabeef/awesome-android-ui',
    forks_url: 'https://api.github.com/repos/wasabeef/awesome-android-ui/forks',
    keys_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/wasabeef/awesome-android-ui/teams',
    hooks_url: 'https://api.github.com/repos/wasabeef/awesome-android-ui/hooks',
    issue_events_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/events',
    assignees_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/branches{/branch}',
    tags_url: 'https://api.github.com/repos/wasabeef/awesome-android-ui/tags',
    blobs_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/languages',
    stargazers_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/stargazers',
    contributors_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/contributors',
    subscribers_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/subscribers',
    subscription_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/subscription',
    commits_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/merges',
    archive_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/downloads',
    issues_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/labels{/name}',
    releases_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/wasabeef/awesome-android-ui/deployments',
    created_at: '2014-12-24T01:45:03Z',
    updated_at: '2022-07-18T10:04:00Z',
    pushed_at: '2022-05-02T16:32:54Z',
    git_url: 'git://github.com/wasabeef/awesome-android-ui.git',
    ssh_url: 'git@github.com:wasabeef/awesome-android-ui.git',
    clone_url: 'https://github.com/wasabeef/awesome-android-ui.git',
    svn_url: 'https://github.com/wasabeef/awesome-android-ui',
    homepage: '',
    size: 871803,
    stargazers_count: 43176,
    watchers_count: 43176,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 10207,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 16,
    license: {
      key: 'mit',
      name: 'MIT License',
      spdx_id: 'MIT',
      url: 'https://api.github.com/licenses/mit',
      node_id: 'MDc6TGljZW5zZTEz',
    },
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['android', 'awesome', 'ui'],
    visibility: 'public',
    forks: 10207,
    open_issues: 16,
    watchers: 43176,
    default_branch: 'master',
  },
  {
    id: 456267270,
    node_id: 'R_kgDOGzIWBg',
    name: 'KodluyoruzHTMLOdev1',
    full_name: 'cetinsangu/KodluyoruzHTMLOdev1',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/KodluyoruzHTMLOdev1',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1',
    forks_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzHTMLOdev1/deployments',
    created_at: '2022-02-06T20:42:41Z',
    updated_at: '2022-02-06T20:42:48Z',
    pushed_at: '2022-02-06T22:47:39Z',
    git_url: 'git://github.com/cetinsangu/KodluyoruzHTMLOdev1.git',
    ssh_url: 'git@github.com:cetinsangu/KodluyoruzHTMLOdev1.git',
    clone_url: 'https://github.com/cetinsangu/KodluyoruzHTMLOdev1.git',
    svn_url: 'https://github.com/cetinsangu/KodluyoruzHTMLOdev1',
    homepage: null,
    size: 2,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 457069564,
    node_id: 'R_kgDOGz5T_A',
    name: 'cetinsangu',
    full_name: 'cetinsangu/cetinsangu',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/cetinsangu',
    description: 'Config files for my GitHub profile.',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/cetinsangu',
    forks_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/cetinsangu/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/cetinsangu/deployments',
    created_at: '2022-02-08T19:12:51Z',
    updated_at: '2022-02-08T19:12:51Z',
    pushed_at: '2022-06-27T09:40:57Z',
    git_url: 'git://github.com/cetinsangu/cetinsangu.git',
    ssh_url: 'git@github.com:cetinsangu/cetinsangu.git',
    clone_url: 'https://github.com/cetinsangu/cetinsangu.git',
    svn_url: 'https://github.com/cetinsangu/cetinsangu',
    homepage: 'https://github.com/cetinsangu',
    size: 21,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: false,
    has_projects: true,
    has_downloads: true,
    has_wiki: false,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: ['config', 'github-config'],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 457069816,
    node_id: 'R_kgDOGz5U-A',
    name: 'kodluyoruzuygulamahtml',
    full_name: 'cetinsangu/kodluyoruzuygulamahtml',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/kodluyoruzuygulamahtml',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml',
    forks_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzuygulamahtml/deployments',
    created_at: '2022-02-08T19:13:37Z',
    updated_at: '2022-02-08T19:16:40Z',
    pushed_at: '2022-02-08T19:16:36Z',
    git_url: 'git://github.com/cetinsangu/kodluyoruzuygulamahtml.git',
    ssh_url: 'git@github.com:cetinsangu/kodluyoruzuygulamahtml.git',
    clone_url: 'https://github.com/cetinsangu/kodluyoruzuygulamahtml.git',
    svn_url: 'https://github.com/cetinsangu/kodluyoruzuygulamahtml',
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 457082219,
    node_id: 'R_kgDOGz6Faw',
    name: 'HTMLOdev3',
    full_name: 'cetinsangu/HTMLOdev3',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/HTMLOdev3',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3',
    forks_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/forks',
    keys_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/HTMLOdev3/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/HTMLOdev3/deployments',
    created_at: '2022-02-08T19:52:44Z',
    updated_at: '2022-02-08T19:52:51Z',
    pushed_at: '2022-02-08T19:52:48Z',
    git_url: 'git://github.com/cetinsangu/HTMLOdev3.git',
    ssh_url: 'git@github.com:cetinsangu/HTMLOdev3.git',
    clone_url: 'https://github.com/cetinsangu/HTMLOdev3.git',
    svn_url: 'https://github.com/cetinsangu/HTMLOdev3',
    homepage: null,
    size: 2,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 458310869,
    node_id: 'R_kgDOG1FE1Q',
    name: 'KodluyoruzCSSOdev1',
    full_name: 'cetinsangu/KodluyoruzCSSOdev1',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/KodluyoruzCSSOdev1',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1',
    forks_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/KodluyoruzCSSOdev1/deployments',
    created_at: '2022-02-11T19:12:54Z',
    updated_at: '2022-02-11T19:13:01Z',
    pushed_at: '2022-02-11T19:12:58Z',
    git_url: 'git://github.com/cetinsangu/KodluyoruzCSSOdev1.git',
    ssh_url: 'git@github.com:cetinsangu/KodluyoruzCSSOdev1.git',
    clone_url: 'https://github.com/cetinsangu/KodluyoruzCSSOdev1.git',
    svn_url: 'https://github.com/cetinsangu/KodluyoruzCSSOdev1',
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 459995030,
    node_id: 'R_kgDOG2r3lg',
    name: 'KODLUYORUZCSSODEV2',
    full_name: 'cetinsangu/KODLUYORUZCSSODEV2',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV2',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2',
    forks_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV2/deployments',
    created_at: '2022-02-16T12:29:34Z',
    updated_at: '2022-02-16T12:29:41Z',
    pushed_at: '2022-02-16T12:30:21Z',
    git_url: 'git://github.com/cetinsangu/KODLUYORUZCSSODEV2.git',
    ssh_url: 'git@github.com:cetinsangu/KODLUYORUZCSSODEV2.git',
    clone_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV2.git',
    svn_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV2',
    homepage: null,
    size: 8,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 460050174,
    node_id: 'R_kgDOG2vO_g',
    name: 'KODLUYORUZCSSODEV3',
    full_name: 'cetinsangu/KODLUYORUZCSSODEV3',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV3',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3',
    forks_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/KODLUYORUZCSSODEV3/deployments',
    created_at: '2022-02-16T14:55:54Z',
    updated_at: '2022-02-16T14:56:01Z',
    pushed_at: '2022-02-16T14:56:55Z',
    git_url: 'git://github.com/cetinsangu/KODLUYORUZCSSODEV3.git',
    ssh_url: 'git@github.com:cetinsangu/KODLUYORUZCSSODEV3.git',
    clone_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV3.git',
    svn_url: 'https://github.com/cetinsangu/KODLUYORUZCSSODEV3',
    homepage: null,
    size: 11,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 460972971,
    node_id: 'R_kgDOG3njqw',
    name: 'BOOTSTRAPODEV1',
    full_name: 'cetinsangu/BOOTSTRAPODEV1',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV1',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1',
    forks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV1/deployments',
    created_at: '2022-02-18T19:02:37Z',
    updated_at: '2022-02-18T19:02:45Z',
    pushed_at: '2022-02-18T19:04:37Z',
    git_url: 'git://github.com/cetinsangu/BOOTSTRAPODEV1.git',
    ssh_url: 'git@github.com:cetinsangu/BOOTSTRAPODEV1.git',
    clone_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV1.git',
    svn_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV1',
    homepage: null,
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 460988770,
    node_id: 'R_kgDOG3ohYg',
    name: 'BOOTSTRAPODEV2',
    full_name: 'cetinsangu/BOOTSTRAPODEV2',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV2',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2',
    forks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV2/deployments',
    created_at: '2022-02-18T20:00:19Z',
    updated_at: '2022-02-18T20:00:25Z',
    pushed_at: '2022-02-18T20:00:22Z',
    git_url: 'git://github.com/cetinsangu/BOOTSTRAPODEV2.git',
    ssh_url: 'git@github.com:cetinsangu/BOOTSTRAPODEV2.git',
    clone_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV2.git',
    svn_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV2',
    homepage: null,
    size: 5,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 461570145,
    node_id: 'R_kgDOG4MAYQ',
    name: 'BOOTSTRAPMEDIUMUYGULAMACSANGU',
    full_name: 'cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU',
    forks_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU/deployments',
    created_at: '2022-02-20T17:56:53Z',
    updated_at: '2022-02-23T22:20:06Z',
    pushed_at: '2022-02-20T18:05:49Z',
    git_url: 'git://github.com/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU.git',
    ssh_url: 'git@github.com:cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU.git',
    clone_url:
      'https://github.com/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU.git',
    svn_url: 'https://github.com/cetinsangu/BOOTSTRAPMEDIUMUYGULAMACSANGU',
    homepage: null,
    size: 5574,
    stargazers_count: 1,
    watchers_count: 1,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 1,
    default_branch: 'master',
  },
  {
    id: 461581409,
    node_id: 'R_kgDOG4MsYQ',
    name: 'BOOTSTRAPODEV3',
    full_name: 'cetinsangu/BOOTSTRAPODEV3',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV3',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3',
    forks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/BOOTSTRAPODEV3/deployments',
    created_at: '2022-02-20T18:41:12Z',
    updated_at: '2022-02-20T18:41:19Z',
    pushed_at: '2022-02-20T18:41:16Z',
    git_url: 'git://github.com/cetinsangu/BOOTSTRAPODEV3.git',
    ssh_url: 'git@github.com:cetinsangu/BOOTSTRAPODEV3.git',
    clone_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV3.git',
    svn_url: 'https://github.com/cetinsangu/BOOTSTRAPODEV3',
    homepage: null,
    size: 10,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 462469423,
    node_id: 'R_kgDOG5C5Lw',
    name: 'kodluyoruzalgoritmaodev',
    full_name: 'cetinsangu/kodluyoruzalgoritmaodev',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/kodluyoruzalgoritmaodev',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev',
    forks_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/branches{/branch}',
    tags_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/kodluyoruzalgoritmaodev/deployments',
    created_at: '2022-02-22T20:48:59Z',
    updated_at: '2022-02-22T20:48:59Z',
    pushed_at: '2022-02-22T20:53:06Z',
    git_url: 'git://github.com/cetinsangu/kodluyoruzalgoritmaodev.git',
    ssh_url: 'git@github.com:cetinsangu/kodluyoruzalgoritmaodev.git',
    clone_url: 'https://github.com/cetinsangu/kodluyoruzalgoritmaodev.git',
    svn_url: 'https://github.com/cetinsangu/kodluyoruzalgoritmaodev',
    homepage: null,
    size: 1,
    stargazers_count: 0,
    watchers_count: 0,
    language: null,
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 466758185,
    node_id: 'R_kgDOG9IqKQ',
    name: 'starter',
    full_name: 'cetinsangu/starter',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/starter',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/starter',
    forks_url: 'https://api.github.com/repos/cetinsangu/starter/forks',
    keys_url: 'https://api.github.com/repos/cetinsangu/starter/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/starter/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/starter/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/starter/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/starter/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/starter/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/starter/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/starter/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/starter/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/starter/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/starter/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/starter/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/starter/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/starter/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/cetinsangu/starter/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/starter/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/starter/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/starter/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/starter/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/starter/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/starter/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/starter/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/starter/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/starter/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/starter/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/starter/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/starter/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/cetinsangu/starter/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/starter/issues{/number}',
    pulls_url: 'https://api.github.com/repos/cetinsangu/starter/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/starter/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/starter/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/cetinsangu/starter/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/starter/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/starter/deployments',
    created_at: '2022-03-06T14:16:57Z',
    updated_at: '2022-03-06T14:17:04Z',
    pushed_at: '2022-03-06T19:07:51Z',
    git_url: 'git://github.com/cetinsangu/starter.git',
    ssh_url: 'git@github.com:cetinsangu/starter.git',
    clone_url: 'https://github.com/cetinsangu/starter.git',
    svn_url: 'https://github.com/cetinsangu/starter',
    homepage: null,
    size: 3,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 466832216,
    node_id: 'R_kgDOG9NLWA',
    name: 'diceholdgame',
    full_name: 'cetinsangu/diceholdgame',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/diceholdgame',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/diceholdgame',
    forks_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/diceholdgame/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/diceholdgame/deployments',
    created_at: '2022-03-06T19:13:56Z',
    updated_at: '2022-03-06T19:14:06Z',
    pushed_at: '2022-03-06T19:19:11Z',
    git_url: 'git://github.com/cetinsangu/diceholdgame.git',
    ssh_url: 'git@github.com:cetinsangu/diceholdgame.git',
    clone_url: 'https://github.com/cetinsangu/diceholdgame.git',
    svn_url: 'https://github.com/cetinsangu/diceholdgame',
    homepage: null,
    size: 392,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 468429784,
    node_id: 'R_kgDOG-ur2A',
    name: 'tas_kagit_makas',
    full_name: 'cetinsangu/tas_kagit_makas',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/tas_kagit_makas',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/tas_kagit_makas',
    forks_url: 'https://api.github.com/repos/cetinsangu/tas_kagit_makas/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/tas_kagit_makas/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/tas_kagit_makas/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/tas_kagit_makas/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/tas_kagit_makas/deployments',
    created_at: '2022-03-10T16:44:08Z',
    updated_at: '2022-03-10T16:44:16Z',
    pushed_at: '2022-03-10T17:11:10Z',
    git_url: 'git://github.com/cetinsangu/tas_kagit_makas.git',
    ssh_url: 'git@github.com:cetinsangu/tas_kagit_makas.git',
    clone_url: 'https://github.com/cetinsangu/tas_kagit_makas.git',
    svn_url: 'https://github.com/cetinsangu/tas_kagit_makas',
    homepage: null,
    size: 81,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 489448361,
    node_id: 'R_kgDOHSxjqQ',
    name: 'bettercallslider',
    full_name: 'cetinsangu/bettercallslider',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/bettercallslider',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/bettercallslider',
    forks_url: 'https://api.github.com/repos/cetinsangu/bettercallslider/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/bettercallslider/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/bettercallslider/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/bettercallslider/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/bettercallslider/deployments',
    created_at: '2022-05-06T17:59:00Z',
    updated_at: '2022-05-06T18:11:40Z',
    pushed_at: '2022-05-06T18:46:30Z',
    git_url: 'git://github.com/cetinsangu/bettercallslider.git',
    ssh_url: 'git@github.com:cetinsangu/bettercallslider.git',
    clone_url: 'https://github.com/cetinsangu/bettercallslider.git',
    svn_url: 'https://github.com/cetinsangu/bettercallslider',
    homepage: null,
    size: 8464,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'HTML',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 489941213,
    node_id: 'R_kgDOHTPo3Q',
    name: 'quotegenerator',
    full_name: 'cetinsangu/quotegenerator',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/quotegenerator',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/quotegenerator',
    forks_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/quotegenerator/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/quotegenerator/deployments',
    created_at: '2022-05-08T12:45:01Z',
    updated_at: '2022-05-08T12:47:19Z',
    pushed_at: '2022-05-29T08:32:45Z',
    git_url: 'git://github.com/cetinsangu/quotegenerator.git',
    ssh_url: 'git@github.com:cetinsangu/quotegenerator.git',
    clone_url: 'https://github.com/cetinsangu/quotegenerator.git',
    svn_url: 'https://github.com/cetinsangu/quotegenerator',
    homepage: null,
    size: 6021,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 494818742,
    node_id: 'R_kgDOHX5Vtg',
    name: 'infiniteimages',
    full_name: 'cetinsangu/infiniteimages',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/infiniteimages',
    description:
      'Infinite Random Images with Infinite Scroll | HTML & CSS & Vanilla JavaScript',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/infiniteimages',
    forks_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/infiniteimages/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/infiniteimages/deployments',
    created_at: '2022-05-21T15:17:04Z',
    updated_at: '2022-05-21T15:21:12Z',
    pushed_at: '2022-05-21T15:21:03Z',
    git_url: 'git://github.com/cetinsangu/infiniteimages.git',
    ssh_url: 'git@github.com:cetinsangu/infiniteimages.git',
    clone_url: 'https://github.com/cetinsangu/infiniteimages.git',
    svn_url: 'https://github.com/cetinsangu/infiniteimages',
    homepage: null,
    size: 797,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 495190873,
    node_id: 'R_kgDOHYQDWQ',
    name: 'randomjoke',
    full_name: 'cetinsangu/randomjoke',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/randomjoke',
    description: 'Random Joke',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/randomjoke',
    forks_url: 'https://api.github.com/repos/cetinsangu/randomjoke/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/randomjoke/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/randomjoke/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/randomjoke/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/randomjoke/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/randomjoke/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/randomjoke/deployments',
    created_at: '2022-05-22T22:22:29Z',
    updated_at: '2022-05-23T13:11:01Z',
    pushed_at: '2022-05-26T21:29:12Z',
    git_url: 'git://github.com/cetinsangu/randomjoke.git',
    ssh_url: 'git@github.com:cetinsangu/randomjoke.git',
    clone_url: 'https://github.com/cetinsangu/randomjoke.git',
    svn_url: 'https://github.com/cetinsangu/randomjoke',
    homepage: 'https://cetinsangu.github.io/randomjoke/',
    size: 1842,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'main',
  },
  {
    id: 498909380,
    node_id: 'R_kgDOHbzAxA',
    name: 'COSMOS',
    full_name: 'cetinsangu/COSMOS',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/COSMOS',
    description: 'COSMOS | NASA APOD Feeder App',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/COSMOS',
    forks_url: 'https://api.github.com/repos/cetinsangu/COSMOS/forks',
    keys_url: 'https://api.github.com/repos/cetinsangu/COSMOS/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/COSMOS/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/COSMOS/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/COSMOS/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/COSMOS/tags',
    blobs_url: 'https://api.github.com/repos/cetinsangu/COSMOS/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/git/refs{/sha}',
    trees_url: 'https://api.github.com/repos/cetinsangu/COSMOS/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/cetinsangu/COSMOS/languages',
    stargazers_url: 'https://api.github.com/repos/cetinsangu/COSMOS/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/subscription',
    commits_url: 'https://api.github.com/repos/cetinsangu/COSMOS/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/COSMOS/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/cetinsangu/COSMOS/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/issues{/number}',
    pulls_url: 'https://api.github.com/repos/cetinsangu/COSMOS/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/notifications{?since,all,participating}',
    labels_url: 'https://api.github.com/repos/cetinsangu/COSMOS/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/COSMOS/deployments',
    created_at: '2022-06-01T21:54:54Z',
    updated_at: '2022-06-02T08:29:58Z',
    pushed_at: '2022-06-05T13:02:10Z',
    git_url: 'git://github.com/cetinsangu/COSMOS.git',
    ssh_url: 'git@github.com:cetinsangu/COSMOS.git',
    clone_url: 'https://github.com/cetinsangu/COSMOS.git',
    svn_url: 'https://github.com/cetinsangu/COSMOS',
    homepage: 'https://cetinsangu.github.io/COSMOS/',
    size: 520,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [
      'async-await',
      'javascript',
      'react',
      'reactjs',
      'tailwindcss',
      'usestateuseeffect',
    ],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 500362964,
    node_id: 'R_kgDOHdLu1A',
    name: 'Breaking-Bad-Odin',
    full_name: 'cetinsangu/Breaking-Bad-Odin',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/Breaking-Bad-Odin',
    description:
      'Created a landing page for the Odin Project. Used basic HTML, CSS Flexbox & Grid and a little bit of JavaScript.',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin',
    forks_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/collaborators{/collaborator}',
    teams_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/teams',
    hooks_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/issues/events{/number}',
    events_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/compare/{base}...{head}',
    merges_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/Breaking-Bad-Odin/deployments',
    created_at: '2022-06-06T09:06:06Z',
    updated_at: '2022-06-06T21:58:39Z',
    pushed_at: '2022-06-06T22:12:26Z',
    git_url: 'git://github.com/cetinsangu/Breaking-Bad-Odin.git',
    ssh_url: 'git@github.com:cetinsangu/Breaking-Bad-Odin.git',
    clone_url: 'https://github.com/cetinsangu/Breaking-Bad-Odin.git',
    svn_url: 'https://github.com/cetinsangu/Breaking-Bad-Odin',
    homepage: null,
    size: 22628,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'CSS',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: true,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 507708844,
    node_id: 'R_kgDOHkMFrA',
    name: 'triviapp',
    full_name: 'cetinsangu/triviapp',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/triviapp',
    description: 'A trivia app with complex selections.',
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/triviapp',
    forks_url: 'https://api.github.com/repos/cetinsangu/triviapp/forks',
    keys_url: 'https://api.github.com/repos/cetinsangu/triviapp/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/triviapp/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/triviapp/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/triviapp/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/triviapp/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/triviapp/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/triviapp/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/triviapp/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/triviapp/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/triviapp/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/triviapp/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/triviapp/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/triviapp/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/triviapp/statuses/{sha}',
    languages_url: 'https://api.github.com/repos/cetinsangu/triviapp/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/triviapp/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/triviapp/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/triviapp/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/triviapp/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/triviapp/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/triviapp/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/triviapp/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/triviapp/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/triviapp/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/triviapp/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/triviapp/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/triviapp/{archive_format}{/ref}',
    downloads_url: 'https://api.github.com/repos/cetinsangu/triviapp/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/triviapp/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/triviapp/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/triviapp/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/triviapp/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/triviapp/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/triviapp/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/triviapp/deployments',
    created_at: '2022-06-26T23:40:58Z',
    updated_at: '2022-06-30T11:00:45Z',
    pushed_at: '2022-07-02T08:37:33Z',
    git_url: 'git://github.com/cetinsangu/triviapp.git',
    ssh_url: 'git@github.com:cetinsangu/triviapp.git',
    clone_url: 'https://github.com/cetinsangu/triviapp.git',
    svn_url: 'https://github.com/cetinsangu/triviapp',
    homepage: 'https://cetinsangu-triviapp.vercel.app/',
    size: 2359,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 510867909,
    node_id: 'R_kgDOHnM5xQ',
    name: 'portfolio-v1',
    full_name: 'cetinsangu/portfolio-v1',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/portfolio-v1',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/portfolio-v1',
    forks_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/portfolio-v1/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/portfolio-v1/deployments',
    created_at: '2022-07-05T19:23:00Z',
    updated_at: '2022-07-06T19:31:26Z',
    pushed_at: '2022-07-06T19:30:49Z',
    git_url: 'git://github.com/cetinsangu/portfolio-v1.git',
    ssh_url: 'git@github.com:cetinsangu/portfolio-v1.git',
    clone_url: 'https://github.com/cetinsangu/portfolio-v1.git',
    svn_url: 'https://github.com/cetinsangu/portfolio-v1',
    homepage: 'portfolio-v1-tawny.vercel.app',
    size: 1401,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
  {
    id: 513952393,
    node_id: 'R_kgDOHqJKiQ',
    name: 'githubsearch',
    full_name: 'cetinsangu/githubsearch',
    private: false,
    owner: {
      login: 'cetinsangu',
      id: 41289806,
      node_id: 'MDQ6VXNlcjQxMjg5ODA2',
      avatar_url: 'https://avatars.githubusercontent.com/u/41289806?v=4',
      gravatar_id: '',
      url: 'https://api.github.com/users/cetinsangu',
      html_url: 'https://github.com/cetinsangu',
      followers_url: 'https://api.github.com/users/cetinsangu/followers',
      following_url:
        'https://api.github.com/users/cetinsangu/following{/other_user}',
      gists_url: 'https://api.github.com/users/cetinsangu/gists{/gist_id}',
      starred_url:
        'https://api.github.com/users/cetinsangu/starred{/owner}{/repo}',
      subscriptions_url:
        'https://api.github.com/users/cetinsangu/subscriptions',
      organizations_url: 'https://api.github.com/users/cetinsangu/orgs',
      repos_url: 'https://api.github.com/users/cetinsangu/repos',
      events_url: 'https://api.github.com/users/cetinsangu/events{/privacy}',
      received_events_url:
        'https://api.github.com/users/cetinsangu/received_events',
      type: 'User',
      site_admin: false,
    },
    html_url: 'https://github.com/cetinsangu/githubsearch',
    description: null,
    fork: false,
    url: 'https://api.github.com/repos/cetinsangu/githubsearch',
    forks_url: 'https://api.github.com/repos/cetinsangu/githubsearch/forks',
    keys_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/keys{/key_id}',
    collaborators_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/collaborators{/collaborator}',
    teams_url: 'https://api.github.com/repos/cetinsangu/githubsearch/teams',
    hooks_url: 'https://api.github.com/repos/cetinsangu/githubsearch/hooks',
    issue_events_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/issues/events{/number}',
    events_url: 'https://api.github.com/repos/cetinsangu/githubsearch/events',
    assignees_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/assignees{/user}',
    branches_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/branches{/branch}',
    tags_url: 'https://api.github.com/repos/cetinsangu/githubsearch/tags',
    blobs_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/git/blobs{/sha}',
    git_tags_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/git/tags{/sha}',
    git_refs_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/git/refs{/sha}',
    trees_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/git/trees{/sha}',
    statuses_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/statuses/{sha}',
    languages_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/languages',
    stargazers_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/stargazers',
    contributors_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/contributors',
    subscribers_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/subscribers',
    subscription_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/subscription',
    commits_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/commits{/sha}',
    git_commits_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/git/commits{/sha}',
    comments_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/comments{/number}',
    issue_comment_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/issues/comments{/number}',
    contents_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/contents/{+path}',
    compare_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/compare/{base}...{head}',
    merges_url: 'https://api.github.com/repos/cetinsangu/githubsearch/merges',
    archive_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/{archive_format}{/ref}',
    downloads_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/downloads',
    issues_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/issues{/number}',
    pulls_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/pulls{/number}',
    milestones_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/milestones{/number}',
    notifications_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/notifications{?since,all,participating}',
    labels_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/labels{/name}',
    releases_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/releases{/id}',
    deployments_url:
      'https://api.github.com/repos/cetinsangu/githubsearch/deployments',
    created_at: '2022-07-14T15:24:52Z',
    updated_at: '2022-07-14T15:27:35Z',
    pushed_at: '2022-07-18T09:27:41Z',
    git_url: 'git://github.com/cetinsangu/githubsearch.git',
    ssh_url: 'git@github.com:cetinsangu/githubsearch.git',
    clone_url: 'https://github.com/cetinsangu/githubsearch.git',
    svn_url: 'https://github.com/cetinsangu/githubsearch',
    homepage: 'githubsearch-tawny.vercel.app',
    size: 1122,
    stargazers_count: 0,
    watchers_count: 0,
    language: 'JavaScript',
    has_issues: true,
    has_projects: true,
    has_downloads: true,
    has_wiki: true,
    has_pages: false,
    forks_count: 0,
    mirror_url: null,
    archived: false,
    disabled: false,
    open_issues_count: 0,
    license: null,
    allow_forking: true,
    is_template: false,
    web_commit_signoff_required: false,
    topics: [],
    visibility: 'public',
    forks: 0,
    open_issues: 0,
    watchers: 0,
    default_branch: 'master',
  },
];
